import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../_shared/hooks';
import { fetchFollowUpData, type FollowUpRow } from '../event-manager-client';

export function useFollowUpData(campaignId: string, enabled = true) {
  const { apiFetch } = useApi();

  const query = useQuery<FollowUpRow[]>({
    queryKey: ['launcher', 'campaigns', campaignId, 'follow-up'],
    queryFn: () => fetchFollowUpData(apiFetch, campaignId),
    enabled: !!campaignId && enabled,
    staleTime: 0,
  });

  return {
    rows: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  } as const;
}
